exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".tap-attachments{display:flex;overflow-x:auto}[dir] .tap-attachments{margin-bottom:.7rem}", ""]);

